import { useEffect } from "react";

type TerminalPaymentSuccessPopupProps = {
    showPopup: boolean;
}

export const TerminalPaymentSuccessPopup = ({ showPopup }: TerminalPaymentSuccessPopupProps) => {
    useEffect(() => {
        if (showPopup) {
            document.body.classList.add("overflow-hidden");
        } else {
            document.body.classList.remove("overflow-hidden");
        }

        return () => {
            document.body.classList.remove("overflow-hidden");
        };
    }, [showPopup]);

    if (!showPopup) return null;

    return (
        <div className="fixed inset-0 z-[9999999] flex items-center justify-center bg-black/50">
            <div className="w-[380px] max-w-[90%] rounded-2xl bg-white p-6 shadow-xl flex flex-col items-center text-center">

                <div className="flex justify-center items-center">
                    <img src="/images/success-removebg-preview.png" alt="success" className="h-[120px]" />
                </div>


                {/* Title */}
                <h2 className="text-xl font-semibold text-gray-800 mb-1">
                    Payment Successful
                </h2>

                <p className="text-sm text-gray-600 mb-4">
                    The payment has been completed successfully.
                </p>


            </div>
        </div>
    )
}